import type { SmartSocietyAuthConfig } from '@/types/auth'

export function getSmartSocietyAuthConfig(): SmartSocietyAuthConfig {
  const domain = import.meta.env.VITE_APP_SMART_SOCIETY_DOMAIN as string | undefined
  const clientId = import.meta.env.VITE_APP_SMART_SOCIETY_CLIENT_ID as string | undefined

  if (!domain) {
    throw new Error('Smart Society auth is not configured. Set VITE_APP_SMART_SOCIETY_DOMAIN.')
  }

  if (!clientId) {
    throw new Error('Smart Society auth is not configured. Set VITE_APP_SMART_SOCIETY_CLIENT_ID.')
  }

  return {
    domain,
    clientId,
    audience: import.meta.env.VITE_APP_SMART_SOCIETY_AUDIENCE as string | undefined,
    redirectUri:
      (import.meta.env.VITE_APP_SMART_SOCIETY_REDIRECT_URI as string | undefined) ??
      window.location.origin,
    logoutReturnTo:
      (import.meta.env.VITE_APP_SMART_SOCIETY_LOGOUT_RETURN_TO as string | undefined) ??
      window.location.origin
  }
}
